<template>
  <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
      <div class="text-[#414141]">
          <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">Welcome,</h3>

          <p class="text-[14px] leading-[22px] mb-[0.5rem]">
              Have you mapped out your organization's budget for the next year, three years, or five years? Do you have a financial cushion to handle unexpected funding gaps? Are you prepared to manage a major influx of revenue? Do you want to start paying your staff living wages? How confident are you that your development team is operating effectively?
          </p>

          <p class="text-[14px] leading-[22px] mb-[0.5rem]">
              These questions are critical, yet they often take a backseat to the daily demands of running your organization. To be able to answer these questions, your organization must think and plan strategically. Long-term strategic and financial planning is not just an administrative task; it is the foundation of sustainability, operational efficiency, trust with funders and partners, and the backbone of your fundraising strategy.
          </p>

          <p class="text-[14px] leading-[22px] mb-[0.5rem]">
              Having a strategic plan for fundraising is critical for fundraising success. When you can clearly articulate your vision and mission, core programs and projects, and funding priorities, you build confidence, accountability, and credibility in your work both internally and externally.
          </p>

          <p class="text-[14px] leading-[22px] mb-[0.5rem]">
              Ask A Fundraiser© is here to guide you through the Strategic Planning for Fundraising process, helping you sharpen your focus, streamline your operations, and build a strong and compelling case for support to use as your fundraising playbook.
          </p>

          <p class="text-[14px] leading-[22px] font-bold mb-[0.5rem]">Through 16 Modules, the Ask A Fundraiser© E-Tool will guide you in developing:</p>

          <table class="w-full border-collapse border border-gray-300 mb-4">
              <thead>
                  <tr class="bg-gray-100 border-b border-gray-300">
                      <th class="py-3 px-4 text-[14px] leading-[22px] font-semibold text-left border-r border-gray-300">Fundraising Plan</th>
                      <th class="py-3 px-4 text-[14px] leading-[22px] font-semibold text-left">Fundraising Resources</th>
                  </tr>
              </thead>
              <tbody>
                  <tr class="border-b border-gray-300">
                      <td class="py-3 px-4 text-[14px] leading-[22px] border-r border-gray-300">
                          <ul class="list-disc pl-4 space-y-1">
                              <li>Aspirational Vision and Mission</li>
                              <li>Structured 3-Year Core Annual Programs and New Projects</li>
                              <li>Clear Fundraising Goals</li>
                              <li>Fundraising Narrative & Rationale</li>
                          </ul>
                      </td>
                      <td class="py-3 px-4 text-[14px] leading-[22px]">
                          <ul class="list-disc pl-4 space-y-1">
                              <li>Case for Support</li>
                              <li>Gift Pyramid</li>
                              <li>Stewardship Structure</li>
                              <li>Development Operations Policies & Procedures and Gift Documentation</li>
                          </ul>
                      </td>
                  </tr>
              </tbody>
          </table>

          <p class="text-[14px] leading-[22px] mt-4">
              By collaborating with your team and investing time in this process upfront, you will save countless hours in the fundraising process and strengthen your organization's future.
          </p>

          <p class="text-[14px] leading-[22px] font-semibold mt-4">If you have any questions, our team is ready to help. Thank you for trusting Ask A Fundraiser as your virtual fundraising consulting partners.</p>

          <p class="font-bold mt-2">Anna Barber</p>
          <p>info@askafundraiser.com</p>
      </div>
  </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation'; // Import the validation composable

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style>